import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import arrowIcon from "../../../assets/right-arrow.png";
import qhrFlow from "../../../assets/landingFeatures/qhrFlow.png";
import useMembersStore from "../../../store/members.store";
import { Tooltip } from "antd";
import { MenuOutlined, CloseOutlined } from "@ant-design/icons";
function QHRFlowSidebar({ sidebarOpen, setSidebarOpen, subscriptionIsActive }) {
  const [isHomeCollapsed, setIsHomeCollapsed] = useState(false);
  const [isQHRFlowCollapsed, setIsQHRFlowCollapsed] = useState(false);
  const [isNuJobsCollapsed, setIsNuJobsCollapsed] = useState(true);
  const [isCollapsedTeam, setIsCollapsedTeam] = useState(true);
  const [isCollapsedMy, setIsCollapsedMy] = useState(true);
  const [isCollapsedAllResume, setIsCollapsedAllResume] = useState(true);
  const [isCollapsedInterviews, setIsCollapsedInterviews] = useState(true);
  const [isCollapsedSourcing, setIsCollapsedSourcing] = useState(true);
  const [isCollapsedJD, setIsCollapsedJD] = useState(true);
  const [isCollapsedSelections, setIsCollapsedSelections] = useState(true);
  const [isCollapsedEvaluations, setIsCollapsedEvaluations] = useState(true);

  const handleToggleCollapseTeam = () => {
    setIsCollapsedTeam(!isCollapsedTeam);
  };
  const handleToggleCollapseMy = () => {
    setIsCollapsedMy(!isCollapsedMy);
  };
  const handleToggleCollapseAllResume = () => {
    setIsCollapsedAllResume(!isCollapsedAllResume);
  };
  const handleToggleCollapseInterviews = () => {
    setIsCollapsedInterviews(!isCollapsedInterviews);
  };
  const handleToggleCollapseSourcing = () => {
    setIsCollapsedSourcing(!isCollapsedSourcing);
  };
  const handleToggleCollapsejd = () => {
    setIsCollapsedJD(!isCollapsedJD);
  };

  const handleToggleCollapseSelections = () => {
    setIsCollapsedSelections(!isCollapsedSelections);
  };

  const handleToggleCollapseEvaluations = () => {
    setIsCollapsedEvaluations(!isCollapsedEvaluations);
  };
  return (
    <div>
      <button
        className={`img-toggle ${
          isHomeCollapsed ? "" : "active"
        }`}
        onClick={() => setIsHomeCollapsed(!isHomeCollapsed)}
        data-bs-toggle="collapse"
        data-bs-target="#home-collapse"
        aria-expanded={isCollapsedTeam ? "false" : "true"}
      >
        <img
          src={qhrFlow}
          alt="Arrow"
          width="20"
          height="20"
          className={`arrow-icon me-2`}
        />
        QHRFlow
      </button>

      {!isHomeCollapsed && (
        <div style={{ marginLeft: "10px", marginTop: "10px" }}>
          <div>
            <button
              className={`btn btn-toggle d-inline-flex align-items-center border-0 ${
                isCollapsedTeam ? "" : "active" // Add the active class conditionally
              } sideFont`}
              onClick={handleToggleCollapseTeam}
              data-bs-toggle="collapse"
              data-bs-target="#home-collapse"
              aria-expanded={isCollapsedTeam ? "false" : "true"}
            >
              <img
                src={arrowIcon}
                alt="Arrow"
                width="8"
                height="8"
                className={`arrow-icon me-2 ${isCollapsedTeam ? "" : "rotate"}`}
              />
              Team Assignment
            </button>

            {!isCollapsedTeam && (
              <ul id="home-collapse" className="listShow">
                <li className="list-group-item">
                  <Link
                    className="sidebar-link"
                    to={{ pathname: "/TeamAssignmentPages" }}
                    onClick={() => setSidebarOpen(false)}
                  >
                    Dashboard
                  </Link>
                </li>
                <li className="list-group-item">
                  <Link
                    className="sidebar-link"
                    to={{ pathname: "/teamTaskUpdates" }}
                    onClick={() => setSidebarOpen(false)}
                  >
                    Task Updates
                  </Link>
                </li>

                <li className="list-group-item">
                  <Link
                    className="sidebar-link listShow"
                    to={{ pathname: "/assignedJds" }}
                    onClick={() => setSidebarOpen(false)}
                  >
                    Assigned Jds
                  </Link>
                </li>
                <li className="list-group-item">
                  <Link
                    className="sidebar-link"
                    to={{ pathname: "/teamSelection" }}
                    onClick={() => setSidebarOpen(false)}
                  >
                    Final Selection and Offers
                  </Link>
                </li>
                <li className="list-group-item">
                  <Link
                    className="sidebar-link"
                    to={{ pathname: "/teamStatsAnalytics" }}
                    onClick={() => setSidebarOpen(false)}
                  >
                    Team Analytics
                  </Link>
                </li>                
                {/* Add more list items as needed */}
              </ul>
            )}
            <hr className="sidebar-hr"></hr>
          </div>
          {/* <Link className="sidebar-link" to="/My Assignments">
                Dashboard
            </Link> */}
          <div>
            <button
              className={`btn btn-toggle d-inline-flex align-items-center border-0 ${
                isCollapsedJD ? "" : "active" // Add the active class conditionally
              } sideFont`}
              onClick={handleToggleCollapseMy}
              data-bs-toggle="collapse"
              data-bs-target="#home-collapse"
              aria-expanded={isCollapsedMy ? "false" : "true"}
            >
              <img
                src={arrowIcon}
                alt="Arrow"
                width="8"
                height="8"
                className={`arrow-icon me-2 ${isCollapsedMy ? "" : "rotate"}`}
              />
              My Recruitments
            </button>

            {!isCollapsedMy && (
              <ul id="home-collapse" className="listShow">
                <li className="list-group-item">
                  <Link
                    className="sidebar-link"
                    to={{ pathname: "/myDashboardPages" }}
                    onClick={() => setSidebarOpen(false)}
                  >
                    My dashboard
                  </Link>
                </li>
                <li className="list-group-item">
                  <Link
                    className="sidebar-link"
                    to={{ pathname: "/myInternalTaskUpdates" }}
                    onClick={() => setSidebarOpen(false)}
                  >
                    My Tasks
                  </Link>
                </li>
                <li className="list-group-item">
                  <Link
                    className="sidebar-link listShow"
                    to={{ pathname: "/myJDs" }}
                    onClick={() => setSidebarOpen(false)}
                  >
                    Assigned Jds
                  </Link>
                </li>
                <li className="list-group-item">
                  <Link
                    className="sidebar-link"
                    to={{ pathname: "/mySelection" }}
                    onClick={() => setSidebarOpen(false)}
                  >
                    Final Selection and Offers
                  </Link>
                </li>
                {/* Add more list items as needed */}
              </ul>
            )}
            <hr className="sidebar-hr"></hr>
          </div>

          {/* <Link className="sidebar-link" to="/jds">
                Dashboard
            </Link> */}
          <div>
            <Tooltip
              placement="bottom"
              title={
                subscriptionIsActive ? "" : "Please activate your subscription"
              }
            >
              <button
                className={`btn btn-toggle d-inline-flex align-items-center border-0 ${
                  isCollapsedJD ? "" : "active" // Add the active class conditionally
                } sideFont`}
                onClick={subscriptionIsActive ? handleToggleCollapsejd : null}
                data-bs-toggle="collapse"
                data-bs-target="#home-collapse"
                aria-expanded={isCollapsedJD ? "false" : "true"}
                style={subscriptionIsActive ? {} : { color: "grey" }}
              >
                <img
                  src={arrowIcon}
                  alt="Arrow"
                  width="8"
                  height="8"
                  className={`arrow-icon me-2 ${isCollapsedJD ? "" : "rotate"}`}
                />
                JDs
              </button>
            </Tooltip>

            {!isCollapsedJD && (
              <ul id="home-collapse" className="listShow">
                <li className="list-group-item">
                  <Link
                    className="sidebar-link listShow"
                    to={{ pathname: "/jds" }}
                    onClick={() => setSidebarOpen(false)}
                  >
                    Dashboard
                  </Link>
                </li>
                <li className="list-group-item">
                  <Link
                    className="sidebar-link listShow"
                    to={{ pathname: "/jdAssignments" }}
                    onClick={() => setSidebarOpen(false)}
                  >
                    Assignments
                  </Link>
                </li>
                <li className="list-group-item">
                  <Link
                    className="sidebar-link listShow"
                    to={{ pathname: "/jdsPriorityinternal" }}
                    onClick={() => setSidebarOpen(false)}
                  >
                    Internal Priorities
                  </Link>
                </li>
                <li className="list-group-item">
                  <Link
                    className="sidebar-link listShow"
                    to={{ pathname: "/jdsPriority" }}
                    onClick={() => setSidebarOpen(false)}
                  >
                    Client Priorities
                  </Link>
                </li>    
                <li className="list-group-item">
                  <Link
                    className="sidebar-link listShow"
                    to={{ pathname: "/jdseventpage" }}
                    onClick={() => setSidebarOpen(false)}
                  >
                    Events
                  </Link>
                </li>   

                            
                {/* Add more list items as needed */}
              </ul>
            )}
            <hr className="sidebar-hr"></hr>
          </div>

          <div>
            <button
              className={`btn btn-toggle d-inline-flex align-items-center border-0 ${
                isCollapsedEvaluations ? "" : "active" // Add the active class conditionally
              } sideFont`}
              onClick={handleToggleCollapseEvaluations}
              data-bs-toggle="collapse"
              data-bs-target="#home-collapse"
              aria-expanded={isCollapsedEvaluations ? "false" : "true"}
            >
              <img
                src={arrowIcon}
                alt="Arrow"
                width="8"
                height="8"
                className={`arrow-icon me-2 ${
                  isCollapsedEvaluations ? "" : "rotate"
                }`}
              />
              Evaluations
            </button>

            {!isCollapsedEvaluations && (
              <ul id="home-collapse" className="listShow">
                <li className="list-group-item"></li>
                <li className="list-group-item">
                  <Link
                    className="sidebar-link"
                    to={{
                      pathname: "/currentEvals",
                    }}
                    onClick={() => setSidebarOpen(false)}
                  >
                    All Evaluations
                  </Link>
                </li>
                {/* Add more list items as needed */}
              </ul>
            )}
            <hr className="sidebar-hr"></hr>
          </div>

          {/* <Link className="sidebar-link" to="/interviews">
                Dashboard
            </Link> */}
          <div>
            <button
              className={`btn btn-toggle d-inline-flex align-items-center border-0 ${
                isCollapsedInterviews ? "" : "active" // Add the active class conditionally
              } sideFont`}
              onClick={handleToggleCollapseInterviews}
              data-bs-toggle="collapse"
              data-bs-target="#home-collapse"
              aria-expanded={isCollapsedInterviews ? "false" : "true"}
            >
              <img
                src={arrowIcon}
                alt="Arrow"
                width="8"
                height="8"
                className={`arrow-icon me-2 ${
                  isCollapsedInterviews ? "" : "rotate"
                }`}
              />
              Interviews
            </button>

            {!isCollapsedInterviews && (
              <ul id="home-collapse" className="listShow">
                <li className="list-group-item"></li>
                <li className="list-group-item">
                  <Link
                    className="sidebar-link"
                    to={{
                      pathname: "/InterviewCalendar",
                    }}
                    onClick={() => setSidebarOpen(false)}
                  >
                    Interview Calender
                  </Link>
                </li>
                {/* Add more list items as needed */}
              </ul>
            )}
            <hr className="sidebar-hr"></hr>
          </div>
          <div>
            <button
              className={`btn btn-toggle d-inline-flex align-items-center border-0 ${
                isCollapsedAllResume ? "" : "active" // Add the active class conditionally
              } sideFont`}
              onClick={handleToggleCollapseAllResume}
              data-bs-toggle="collapse"
              data-bs-target="#home-collapse"
              aria-expanded={isCollapsedAllResume ? "false" : "true"}
            >
              <img
                src={arrowIcon}
                alt="Arrow"
                width="8"
                height="8"
                className={`arrow-icon me-2 ${
                  isCollapsedAllResume ? "" : "rotate"
                }`}
              />
              Resume DataBase
            </button>

            {!isCollapsedAllResume && (
              <ul id="home-collapse" className="listShow">
                <li className="list-group-item">
                  <Link
                    className="sidebar-link listShow"
                    to={{
                      pathname: "/resumeDataBase",
                    }}
                    onClick={() => setSidebarOpen(false)}
                  >
                    Resumes
                  </Link>
                </li>

                {/* Add more list items as needed */}
              </ul>
            )}
            <hr className="sidebar-hr"></hr>
          </div>

          <div>
            <button
              className={`btn btn-toggle d-inline-flex align-items-center border-0 ${
                isCollapsedSelections ? "" : "active" // Add the active class conditionally
              } sideFont`}
              onClick={handleToggleCollapseSelections}
              data-bs-toggle="collapse"
              data-bs-target="#home-collapse"
              aria-expanded={isCollapsedSelections ? "false" : "true"}
            >
              <img
                src={arrowIcon}
                alt="Arrow"
                width="8"
                height="8"
                className={`arrow-icon me-2 ${
                  isCollapsedSelections ? "" : "rotate"
                }`}
              />
              Selections
            </button>

            {!isCollapsedSelections && (
              <ul id="home-collapse" className="listShow">
                <li className="list-group-item">
                  <Link
                    className="sidebar-link listShow"
                    to={{
                      pathname: "/allSelections",
                    }}
                    onClick={() => setSidebarOpen(false)}
                  >
                    All Selections
                  </Link>
                </li>

                {/* Add more list items as needed */}
              </ul>
            )}
            <hr className="sidebar-hr"></hr>
          </div>

          {/* <Link className="sidebar-link" to="/resume_source">
                Resume Sourcing
            </Link> */}
          <div style={{ marginBottom: "60px" }}>
            <button
              className={`btn btn-toggle d-inline-flex align-items-center border-0 ${
                isCollapsedSourcing ? "" : "active" // Add the active class conditionally
              } sideFont`}
              onClick={handleToggleCollapseSourcing}
              data-bs-toggle="collapse"
              data-bs-target="#home-collapse"
              aria-expanded={isCollapsedSourcing ? "false" : "true"}
            >
              <img
                src={arrowIcon}
                alt="Arrow"
                width="10"
                height="10"
                className={`arrow-icon me-2 ${
                  isCollapsedSourcing ? "" : "rotate"
                }`}
              />
              Applications and Sourcing
            </button>

            {!isCollapsedSourcing && (
              <ul id="home-collapse" className="">
                <li className="list-group-item">             
                  <Link
                    className="sidebar-link"
                    to="/sourcing"
                    onClick={() => setSidebarOpen(false)}
                  >
                    Team
                  </Link>
                </li>
                <li className="list-group-item">
                  <Link
                    className="sidebar-link"
                    to="/sourcingNujobs"
                    onClick={() => setSidebarOpen(false)}
                  >
                    NuJobs
                  </Link>
                </li>   
                <li className="list-group-item">
                  <Link
                    className="sidebar-link"
                    to="/sourcingAutomation"
                    onClick={() => setSidebarOpen(false)}
                  >
                    Automation
                  </Link>
                </li>                               
                <li className="list-group-item">
                  <Link
                    className="sidebar-link"
                    to="/sourcingVendors"
                    onClick={() => setSidebarOpen(false)}
                  >
                    Vendors
                  </Link>
                </li>

                {/* Add more list items as needed */}
              </ul>
            )}
          </div>
        </div>
      )}
      <hr className="sidebar-hr"></hr>
    </div>
  );
}

export default QHRFlowSidebar;
